import React from "react";
import { withRouter } from "react-router-dom";
import ReactToPrint from "react-to-print";
import PrintTopic from "./PrintTopic";
import TopicHeaderContent from "./TopicHeaderContent";
import ShareComponent from "./ShareComponent";

class TopicHeader extends React.Component {
  constructor() {
    super();
    this.state = {
      openModel: false,
    };
  }
  downloadFile = (fileJson) => {
    //window.open(Object.values(fileJson)[0], "_blank");
    window.location.href = Object.values(fileJson)[0];
  };
  viewAllHandouts = () => {
    let { history } = this.props;
    let path = "/handout-details";
    history.push(path);
  };
  openModel = () => {
    document.querySelector("body").classList.add("stop-body-scroll");
    this.setState({
      openModel: true,
    });
  };
  closeModel = () => {
    document.querySelector("body").classList.remove("stop-body-scroll");
    this.setState({
      openModel: false,
    });
  };
  render() {
    return (
      <>
        <ShareComponent show={this.state.openModel} onClose={this.closeModel} />
        <div className="topic-detail-header-component">
          <div className="header">
            <div className="header-content">
              <TopicHeaderContent
                author={this.props.author}
                topContent={this.props.topContent}
                bookTitle={this.props.bookTitle}
                topicTitle={this.props.topicTitle}
              />
              <div className="button-box">
                {this.props.handout !== null ? (
                  <button
                    className="button orange-button"
                    onClick={() => {
                      this.downloadFile(this.props.handout);
                    }}
                  >
                    <i className="fa fa-download" aria-hidden="true"></i>
                    Download Handout
                  </button>
                ) : (
                  ""
                )}
                <button
                  className="button white-button pl10"
                  onClick={this.viewAllHandouts}
                >
                  View all Client Handouts
                </button>
                <button
                  className="button white-button"
                  onClick={this.openModel}
                >
                  <i className="fa fa-share" aria-hidden="true"></i>Share
                </button>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <button className="button white-button">
                        <i className="fa fa-print" aria-hidden="true"></i>Print
                      </button>
                    );
                  }}
                  content={() => this.componentRef}
                />
              </div>
              <div style={{ display: "none" }}>
                <PrintTopic
                  author={this.props.author}
                  topContent={this.props.topContent}
                  bookTitle={this.props.bookTitle}
                  topicTitle={this.props.topicTitle}
                  content={this.props.printContent}
                  ref={(el) => (this.componentRef = el)}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(TopicHeader);
